import React from 'react';
import { titulosPocos } from './titulosPocos';
import { Box, Checkbox, FormControlLabel, MenuItem, TextField } from '@mui/material';

// Descritores somente para campos simples; regras permanecem nos formulários.
export default function Campos({ fields, dados, setDados, disabled = false }) {
    return <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' }, gap: 2, my: 2 }}>
        {fields.map(({ name, label, type = 'text', options, required, help, full, title, ...props }) => {
            const descricao = title || titulosPocos[name] || help || label;
            const change = value => setDados(prev => ({ ...prev, [name]: value }));
            if (type === 'boolean') return <FormControlLabel key={name} label={label} title={descricao} control={<Checkbox checked={Boolean(dados[name])} disabled={disabled} onChange={e => change(e.target.checked)} />} />;
            return <TextField key={name} label={label} title={descricao} value={dados[name] ?? ''} size="small" fullWidth
                disabled={disabled} required={required} type={options ? undefined : type === 'decimal' ? 'text' : type}
                select={Boolean(options)} onChange={e => change(e.target.value)} helperText={help}
                inputProps={type === 'decimal' ? { inputMode: 'decimal' } : undefined}
                InputLabelProps={['date', 'time', 'datetime-local'].includes(type) ? { shrink: true } : undefined}
                sx={{ gridColumn: full ? '1 / -1' : undefined }} {...props}>
                {options?.map(o => <MenuItem key={String(o.value)} value={o.value}>{o.label}</MenuItem>)}
            </TextField>;
        })}
    </Box>;
}
export const campo = (name, label, type, extra = {}) => ({ name, label, type, ...extra });
export const escolhas = values => values.map(value => ({ value, label: value.replaceAll('_', ' ') }));
export const opcional = items => [{ value: '', label: 'Não informado' }, ...items];
